import React, { Component } from 'react';
import { usePromiseTracker } from "react-promise-tracker";
import { BeatLoader } from 'react-spinners';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

export const LoadingSpinerComponent = (props) => {
    const { promiseInProgress } = usePromiseTracker();
    const styles = {
        modal: {
            backgroundColor: "transparent",
            boxShadow: "none",
            display: "flex",
            overflow: "none",
        },
    };

    return (
        <div>
            {
                <Modal
                    open={promiseInProgress}
                    onClose={promiseInProgress}
                    center
                    styles={styles}
                    //animationDuration={1000}
                    focusTrapped={false}
                    showCloseIcon={false}>
                    <div><BeatLoader color={"#00E676"} size={25} /></div>
                </Modal>
            }
        </div>
    )
};